import _axios from 'axios'

var baseURL = '/api'

if (window.location.hostname.match(/localhost|10.0.0.40/)) {
	baseURL = 'http://10.0.0.40:5000/api'
}

const axios = {
	get: async function (url, opt = {}) {
		try {
			return _axios.get(baseURL + url, ...opt)
		}
		catch (e) {
			console.log(e)
		}
		return null
	},
	post: async function (url, data = {}, opt = {}) {
		try {
			return _axios.post(baseURL + url, data, opt)
		} catch (e) { console.log(e) }
		return null
	}
}
export default axios